export default "__VITE_ASSET__da5c7c2d__"